import React, { useEffect, useState } from 'react';
import GridContainer from 'components/Grid/GridContainer';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Modal from 'components/Tvendo/Common/ModalBase';
import GridItem from 'components/Grid/GridItem';
import { TextField } from '@material-ui/core';
import { wsGetAll } from 'services/WService';
import { wsPost } from 'services/WService';

function AddZoneSellerModal(props) {
  const { model, setOpen, showNotify } = props;
  const [bureaus, setBureaus] = useState([]);
  const [marks, setMarks] = useState([]);
  const [providers, setProviders] = useState([]);
  const [selectedBureau, setSelectedBureau] = useState();
  const [selectedMark, setSelectedMark] = useState();
  const [selectedProvider, setSelectedProvider] = useState();
  
  async function listBureaus(baseZoneId) {
    let res = await wsGetAll(`base/bureau?base_zone_id=${baseZoneId}`);
    if (res.success) {
      setBureaus(res.data);
    }
  }

  async function listMarks() {
    let res = await wsGetAll(`logi/mark`);
    if (res.success) {
      setMarks(res.data);
    }
  }

  async function listProviders() {
    let res = await wsGetAll(`base/business-partner?CardType=S&QryGroup1=Y`);
    if (res.success) {
      setProviders(res.data);
    }
  }

  useEffect(() => {
    if (model.sellerQuota === undefined) return;
    if (model.quotaZone === undefined) return;
    
    listBureaus(model.quotaZone.base_zone_id);
  }, [model]);

  useEffect(() => {
    listMarks();
    listProviders();
  }, []);

  async function onSubmit() {
    let res = await wsPost(`quota/zone/${model.quotaZone.id}/seller`, {
      base_seller_id: model.sellerQuota.seller.id,
      base_business_partner_id: selectedProvider,
      logi_mark_id: selectedMark,
      base_bureau_id: selectedBureau,
    });

    if (res.success) {
      model.loadDetails();
      showNotify(res.message);
    } else {
      showNotify(res.message, 'error');
      throw Error('Error xd');
    }
  }

  return (
    <Modal
      title={`Agregar vendedor`}
      model={model}
      setOpen={() => {
        setOpen({ open: false });
      }}
      onSubmit={onSubmit}
      entity=""
    >
      <GridContainer>
        <GridItem xs={12}>
          <TextField
            label="Vendedor"
            fullWidth
            value={model.sellerQuota?.seller?.SlpName || ''}
            disabled
          />
        </GridItem>
        {/* Proveedor */}
        <GridItem xs={12}>
          <Autocomplete
            options={providers}
            value={providers.find((provider) => provider.id === selectedProvider) || null}
            getOptionLabel={(option) => option.CardName}
            renderInput={(params) => (
              <TextField {...params} label="Proveedor" margin="normal" required />
            )}
            onChange={(_, item) => {
              if (!!item) {
                return setSelectedProvider(item.id);
              }
              setSelectedProvider(undefined);
            }}
          />
        </GridItem>
        {/* Mesas */}
        <GridItem xs={12}>
          <Autocomplete
            options={bureaus}
            value={bureaus.find((bureau) => bureau.id === selectedBureau) || null}
            getOptionLabel={(option) => option.description}
            renderInput={(params) => (
              <TextField {...params} label="Mesa" margin="normal" required />
            )}
            onChange={(_, item) => {
              if (!!item) {
                return setSelectedBureau(item.id);
              }
              setSelectedBureau(undefined);
            }}
          />
        </GridItem>
        {/* Marcas */}
        <GridItem xs={12}>
          <Autocomplete
            options={marks}
            value={marks.find((mark) => mark.id === selectedMark) || null}
            getOptionLabel={(option) => option.description}
            renderInput={(params) => (
              <TextField {...params} label="Marca" margin="normal" required />
            )}
            onChange={(_, item) => {
              if (!!item) {
                return setSelectedMark(item.id);
              }
              setSelectedMark(undefined);
            }}
          />
        </GridItem>
      </GridContainer>
    </Modal>
  );
}

export default AddZoneSellerModal;
